import { render, staticRenderFns } from "./ProductList3.vue?vue&type=template&id=0acac98c&scoped=true&"
import script from "./ProductList3.vue?vue&type=script&lang=js&"
export * from "./ProductList3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acac98c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0acac98c')) {
      api.createRecord('0acac98c', component.options)
    } else {
      api.reload('0acac98c', component.options)
    }
    module.hot.accept("./ProductList3.vue?vue&type=template&id=0acac98c&scoped=true&", function () {
      api.rerender('0acac98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Content/components/ProductList3.vue"
export default component.exports